import type { ReferencedEntry } from 'contentful';
import React from 'react';

import { getContentType } from 'utils/CloverdotcomEntryUtil';
import { getSys } from 'utils/EntryUtil';

import type { IEntryWrapperProps } from './IEntryWrapperProps';
import { withEntryAttributes } from './WithEntryAttributes';

interface IEntryDataAttributes {
  'data-entry-id'?: string;
  'data-field'?: string;
  'data-content-type'?: string;
}
/**
 * Useful for standardizing the data attributes of components which render contentful entries
 * will automatically apply data-entry-id and data-content-type data attributes to the component
 *
 * it is up to the wrapped component to properly spread these extra attributes
 *
 * @param WrappedComponent the component to wrap
 */
export function applyEntryDataAttributes<
  T,
  E extends ReferencedEntry<T> = ReferencedEntry<T>,
  P extends IEntryWrapperProps<T, E> & IEntryDataAttributes = IEntryWrapperProps<T, E> & IEntryDataAttributes,
>(WrappedComponent: React.ComponentType<P>) {
  return withEntryAttributes<T, E, P>(
    ({ entry, field }) =>
      ({
        'data-entry-id': getSys(entry, 'id'),
        'data-field': field ? `${field}` : undefined,
        'data-content-type': getContentType(entry),
      } as P),
  )(WrappedComponent);
}
